// Wrapper classes

export const DEFAULT_WRAPPER = 'border border-solid border-gray-main';
export const DEFAULT_WRAPPER_FOCUSED =
  'border border-solid border-primary-main';
export const ERROR_WRAPPER = 'border border-solid border-red-main';
export const CHECK_WRAPPER = 'border border-solid border-green-main';
export const DISABLED_WRAPPER =
  'border border-solid border-gray-lighter bg-gray-lighter';

export const WRAPPER_STATES = {
  default: DEFAULT_WRAPPER,
  'default-focused': DEFAULT_WRAPPER_FOCUSED,
  error: ERROR_WRAPPER,
  'error-focused': ERROR_WRAPPER,
  check: CHECK_WRAPPER,
  'check-focused': CHECK_WRAPPER,
  disabled: DISABLED_WRAPPER,
  'disabled-focused': DISABLED_WRAPPER,
};

const DARK_WRAPPER = 'bg-gray-dark-16';
const DARK_DISABLED_WRAPPER = 'bg-gray-dark-16';

export const WRAPPER_STATES_DARK = {
  default: DARK_WRAPPER,
  disabled: DARK_DISABLED_WRAPPER,
};

// Input classes

export const BASE_INPUT = 'crehana-ui-input w-full z-1 border-0 resize-none focus:outline-none min-h-40 bg-transparent';

export const FOCUSED_INPUT = ({ white }: { white?: boolean }) =>
  `${white ? 'text-white' : 'text-base-main'} pt-24 pb-8`;

export const FOCUSED_AREA = ({ white }: { white?: boolean }) =>
  `${white ? 'text-white' : 'text-base-main'} mt-24 pt-0 pb-16`;

export const DEFAULT_INPUT = ({ white }: { white?: boolean }) =>
  white
    ? 'text-white caret-primary-lighter'
    : 'text-base-main caret-primary-main';

export const ERROR_INPUT = ({ white }: { white?: boolean }) =>
  `${white ? 'text-white' : 'text-base-main'} caret-red-main`;

export const CHECK_INPUT = ({ white }: { white?: boolean }) =>
  `${white ? 'text-white' : 'text-base-main'} caret-green-main`;

export const DISABLED_INPUT = ({ white }: { white?: boolean }) =>
  white ? 'text-gray-dark' : 'text-base-lighter opacity-80';

export const INPUT_STATES = {
  default: DEFAULT_INPUT,
  error: ERROR_INPUT,
  check: CHECK_INPUT,
  disabled: DISABLED_INPUT,
};

// Error text classes

export const ERROR_TEXT =
  'absolute left-0 bottom-0 font-nun text-11 leading-12 tracking-1 text-red-main';
